export const getToastSubTexts = (mode) => {
  switch (mode) {
    case 'create': {
      return {
        successSubText: 'created',
        failureSubText: 'create',
      };
    }
    case 'edit': {
      return {
        successSubText: 'updated',
        failureSubText: 'update',
      };
    }
  }
};
